import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteMultipleSkillsMutation($input: DeleteMultipleSkillsInput!) {
		deleteMultipleSkills(input: $input) {
			deletedSkillIds
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.companyId,
			connectionKeys: [
				{
					key: 'Company_skills',
				},
			],
			pathToConnection: ['company', 'skills'],
			deletedIDFieldName: 'deletedSkillIds',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteMultipleSkills: {
			deletedSkillIds: input.ids,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Skills Deleted');
	const cleanedInput = omit(input, ['companyId']);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
